import LocomotiveScroll from "locomotive-scroll";
const imagesLoaded = require("imagesloaded");
import { isMobile, select, map, clamp } from "./Helper";




/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
             global variable scroll 
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

var scroll;






function smooth(scrollContainer) {
    let currentScrollContainer = document.querySelector(
        "[data-scroll-container]"
    );
    let options = {
        el: currentScrollContainer,
        smooth: true,
        getSpeed: true,
        getDirection: true,
    };

    if (currentScrollContainer.getAttribute("data-horizontal") == "true") {
        options.direction = "horizontal";
        options.gestureDirection = "both";
        options.smartphone = { smooth: false };
        options.reloadOnContextChange = true;
    }

    scroll = new LocomotiveScroll(options);





    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
         Update scroll height when all images loaded 
      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

    imagesLoaded(currentScrollContainer, { background: true }, function () {
        setTimeout(() => { scroll.update() }, 300)
    });

    


}

export { scroll, smooth };